import { Component, ViewChild } from '@angular/core';
import {
  breadcrumb,
  link,
  stat,
} from '../../../layout/header/header.component';
import {
  ConfirmEventType,
  ConfirmationService,
  MenuItem,
  Message,
  MessageService,
  SelectItem,
  TreeNode,
} from 'primeng/api';
import { Table } from 'primeng/table';
import { DataService } from 'src/app/services/data.service';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import icons from '../../../../misc/data/icons.json';
import { TreeSelectQuestion } from 'src/app/misc/component/dynamic-form/question-treeselect';
import entities from '../../../../misc/data/entities.json';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';

import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-position',
  templateUrl: './position.component.html',
  styleUrls: ['./position.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class PositionComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  @ViewChild('dt')
  dt!: Table;

  messages: Message[] = [];
  translator:TranslatorPipe = new TranslatorPipe()

  cols: any[] = [];
  exportColumns: { title: any; dataKey: any }[] = [];

  treedata: TreeNode[] = [];
  header = 'Positions';
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-chevron-circle-right',
      link: '/admin/users/roles',
    },
    {
      name: 'Permissions',
      icon: 'pi pi-shield',
      link: '/admin/users/roles/permission',
    },
    // {
    //   name: 'Interface',
    //   icon: 'pi pi-flag',
    //   link: '/admin/users/roles/interface',
    // },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: 'Role Management', link: '/admin/users/roles' },
    { name: 'Position', link: '/admin/users/roles/position' },
  ];
  stats: stat[] = [];

  maxID = entities.reduce((prev: any, current: any) => {
    return prev.id > current.id ? prev : current;
  }).id;

  catdata: any[] = [];

  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  constructor(
    public dataService: DataService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit() {
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });

    Promise.all([
      this.getTreeData(),
      this.getPositions(),
      this.makequestion(),
    ]).then((e) => {
      this.skelition = false;
    });
  }

  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  getTreeData() {
    var _ministries: TreeNode[] = [];
    var _entities: TreeNode[] = [];
    var _ous: TreeNode[] = [];

    var level1 = entities.filter((entity: any) => {
      return !entity.parent;
    });
    console.log('====>', level1);
    level1.forEach((item: any) => {
      if (item.type) {
        if (item.type?.name == 'ministry') {
          _ministries.push({
            label: item.name,
            data: item.image_sq,
            children: this.findAll(item.name),
          });
        } else if (item.type?.name == 'entity') {
          _entities.push({ label: item.name, data: item.image_sq });
        } else {
          _ous.push({ label: item.name, data: item.image_sq });
        }
      } else {
        _ous.push({ label: item.name, data: item.image_sq });
      }
    });

    this.treedata = [
      {
        label: 'الجهات المشاركة',
        expanded: false,
        data: '/public/ous/19eac9488f9377b374788d8ea91d7be7.png',
        children: [
          {
            label: 'الوزارات',
            data: 'pi pi-briefcase',
            expanded: false,
            children: _ministries,
          },
          {
            label: 'كيانات أخرى',
            data: 'pi pi-building',
            expanded: false,
            children: _entities,
          },
          {
            label: 'وحدة التنظيم',
            data: 'pi pi-sitemap',
            expanded: false,
            children: _ous,
          },
        ],
      },
    ];
  }

  findAll(name: string) {
    var children: TreeNode[] = [];
    var temp = entities.filter((item: any) => {
      return item.parent?.name == name;
    });
    if (temp.length > 0) {
      temp.forEach((item: any) => {
        children.push({
          label: item.name,
          data: item.image_sq,
          children: this.findAll(item.name),
        });
      });
    }
    return children;
  }

  // Add New Position

  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: 'اسم فئة الوحدة التنظيمية',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new TreeSelectQuestion({
        key: 'ous',
        label: 'Select OU',
        treeOptions: this.treedata,
        order: 2,
        icon: 'pi pi-file',
        filter: true,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'Active',
        options: [
          { label: 'نعم', icon: 'pi pi-check-circle', value: true },
          { label: 'لا', icon: 'pi pi-times-circle', value: false },
        ],
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
        value:true,
        visibility:"false"
      }),
    ];
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;
      let ous = this.getParentIds(data.ous).reverse();
      ous.push(data.ous.label);
      data.ous = ous;
      console.log('===>REcieve Data', data, ous);
      let res = await this.dataService.postData('role/position/', data);
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();

      console.log('=Test==>', res.data.data);
      this.catdata.push(res.data.data);
      console.log('ADDED DATA', this.catdata);
      this.data.unshift({
        ID: { n: res.data.data._id, i: 'pi pi-angle-left' },
        Name: { n: data.name, i:  data.icon },
        Active: {
          n: data.active,
          i: data.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
        },
        Action: [
          {
            n: 'Delete',
            i: 'pi pi-times',
            s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
          },
          {
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          },
        ],
      });
      this.updatePositionCount();
    } catch (error) {
      console.log(error);
    }
  };

  getParentIds(object: any): any {
    const parentIds = [];

    if (object.parent) {
      parentIds.push(object.parent.label);
      parentIds.push(...this.getParentIds(object.parent));
    }

    return parentIds;
  }

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;
      let res = await this.dataService.postData(
        'role/position/',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      // updating in table
      const myObject = this.data.find((item) => item.ID.n === data._id);
      if (myObject) {
        (myObject.ID = { n: data._id, i: 'pi pi-angle-left' }),
          (myObject.Name.n = data.name),
          (myObject.Name.i = data.icon);
        myObject.Active.n = data.active;
        myObject.Active.i = data.active
          ? 'pi pi-check-circle'
          : 'pi pi-check-circle';
      }

      this.data.map((e, i) => {
        if (e.ID.n === data._id) {
          this.data[i] = myObject;
          return;
        }
      });

      this.catdata.map((e, i) => {
        if (e._id === data._id) {
          this.catdata[i] = data;
          return;
        }
      });
      this.updatePositionCount();
    } catch (error) {
      console.log(error);
    }
  };

  private updatePositionCount(): void {
    let activePositions = this.data.filter(
      (item: any) => item.Active.n === true
    ).length;
    let inactivePositions = this.data.length - activePositions;
    this.stats = [
      {
        name: 'Active',
        number: activePositions,
        icon: 'pi pi-check-circle',
      },
      {
        name: 'Deactive',
        number: inactivePositions,
        icon: 'pi pi-times-circle',
      },
    ];
    console.log('Updating stats', this.stats);
  }

  // Add Table Configuration

  getPositions = async () => {
    try {
      let res = await this.dataService.postData('role/position/get', {});
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.catdata = res.data.data;
      this.catdata.forEach((item: any) => {
        console.log('Console..Item =>', item);
        this.data.push({
          // _id: item._id,
          // ID: { n: this.data.length + 1, i: 'pi pi-angle-left' },
          ID: { n: item._id, i: 'pi pi-angle-left' },
          Name: { n: item.name, i:  item.icon },
          Active: {
            n: item.active,
            i: item.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
          },
          Action: [
            {
              n: 'Delete',
              i: 'pi pi-times',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      });
      this.updatePositionCount();
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deletePosition($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.catdata.find((item) => item._id == $event.id);
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: 'اسم فئة الوحدة التنظيمية',
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-12',
          }),
          new DropdownQuestion({
            key: 'active',
            label: 'Active',
            required: true,
            value: this.updateData?.active,
            options: [
              { label: 'نعم', icon: 'pi pi-check-circle', value: true },
              { label: 'لا', icon: 'pi pi-times-circle', value: false },
            ],
            order: 4,
            className: 'col-12',
          }),
        ];
        // console.log("Update Data ==>",this.catdata,this.updateData);
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }
  deletePosition = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`role/position/?id=${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.data = this.data.filter((item) => item.ID.n !== id);
      this.catdata = this.catdata.filter((item) => item._id !== id);
      this.updatePositionCount();
    } catch (error) {
      console.log(error);
    }
  };
  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel:'نعم',
      rejectLabel:'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }
}
